<template>
    <div class="border-top-header">
        <ul class="header-layout header-layout__submenu">
            <li class="dropdown"
                :class="$route.name === 'Home' || $route.name === 'Регистрационные документы поликлиники'
                || $route.name === 'Вакансии' || $route.name === 'Противодействие коррупции' || $route.name === 'Документы'
                || $route.name === 'Руководство поликлиники' || $route.name === 'История поликлиники'
                || $route.name === 'О поликлинике' ? 'active' : ''">
                <router-link tag="a" :to="{name: 'Home'}" class="dropdown-link">Поликлиника</router-link>
                <ul class="dropdown-content">
                    <li :class="$route.name === 'О поликлинике' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'О поликлинике'}">О поликлинике
                        </router-link>
                    </li>
                    <li :class="$route.name === 'История поликлиники' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'История поликлиники'}">История поликлиники
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Руководство поликлиники' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Руководство поликлиники'}">Руководство поликлиники
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Регистрационные документы поликлиники' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Регистрационные документы поликлиники'}">Регистрационные
                            документы поликлиники
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Документы' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Документы'}">Документы
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Противодействие коррупции' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Противодействие коррупции'}">Противодействие коррупции
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Вакансии' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Вакансии'}">Вакансии
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="dropdown" :class="$route.name === 'Услуги' ? 'active' : ''">
                <router-link :to="{name: 'Услуги'}" class="dropdown-link">Услуги</router-link>
            </li>
            <li class="dropdown"
                :class="{'active':$route.name === 'Наши Врачи' || $route.name === 'Научные работы наших врачей'}">
                <router-link tag="a" :to="{name: 'Наши Врачи'}" class="dropdown-link">Наши Врачи</router-link>
                <ul class="dropdown-content">
                    <li :class="{'active':$route.name === 'Научные работы наших врачей'}">
                        <router-link :to="{name: 'Научные работы наших врачей'}">Научные работы наших врачей
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="dropdown" :class="{'active':$route.name === 'Прейскурант'}">
                <router-link :to="{name: 'Прейскурант'}" class="dropdown-link">Прейскурант</router-link>
            </li>
            <li class="dropdown" :class="{'active':$route.name === 'Расписание'}">
                <router-link :to="{name: 'Расписание'}" class="dropdown-link">Расписание</router-link>
            </li>
            <li class="dropdown" :class="{'active': $route.name === 'Акции'}">
                <router-link tag="a" :to="{name: 'Акции'}" class="dropdown-link">Акции</router-link>
            </li>
            <li class="dropdown"
                :class="$route.name === 'Высокотехнологичная медицинская помощь' || $route.name === 'Сотрудничество со страховыми компаниями'
                || $route.name === 'Специальные программы' || $route.name === 'Подготовка к исследованиям'
                || $route.name === 'Страничка психотерапевта' || $route.name === 'Страничка офтальмолога'
                || $route.name === 'Оформление справок' || $route.name === 'Правила и сроки госпитализации'
                || $route.name === 'Программы годового обслуживания' || $route.name === 'Информация для пациентов'
                || $route.name === 'Ведение беременности' || $route.name === 'Постковидные программы' ? 'active' : ''">
                <a class="dropdown-link" href="#">Пациентам</a>
                <ul class="dropdown-content">
                    <li class="inner-list" :class="{'active': $route.name === 'Специальные программы' ||
                    $route.name === 'Программы годового обслуживания' || $route.name === 'Ведение беременности' ||
                    $route.name === 'Постковидные программы' }">
                        <a href="#">Программы</a>
                        <ul class="dropdown-content-inner">
                            <li :class="{'active': $route.name === 'Программы годового обслуживания'}">
                                <router-link :to="{name: 'Программы годового обслуживания'}">Программы годового
                                    обслуживания
                                </router-link>
                            </li>
                            <li :class="{'active': $route.name === 'Постковидные программы'}">
                                <router-link :to="{name: 'Постковидные программы'}">Постковидные программы</router-link>
                            </li>
                            <li :class="{'active': $route.name === 'Ведение беременности'}">
                                <router-link :to="{name: 'Ведение беременности'}">Ведение беременности</router-link>
                            </li>
                            <li :class="{'active': $route.name === 'Специальные программы'}">
                                <router-link :to="{name: 'Специальные программы'}">Специальные программы</router-link>
                            </li>
                        </ul>
                    </li>
                    <li :class="$route.name === 'Информация для пациентов' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Информация для пациентов'}">Информация для пациентов
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Подготовка к исследованиям' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Подготовка к исследованиям'}">Подготовка к исследованиям
                        </router-link>
                    </li>
                    <li :class="{'active': $route.name === 'Правила и сроки госпитализации'}">
                        <router-link :to="{name: 'Правила и сроки госпитализации'}">Правила и сроки госпитализации
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Оформление справок' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Оформление справок'}">Оформление справок
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Высокотехнологичная медицинская помощь' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Высокотехнологичная медицинская помощь'}">Высокотехнологичная
                            медицинская
                            помощь
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Сотрудничество со страховыми компаниями' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Сотрудничество со страховыми компаниями'}">Сотрудничество со
                            страховыми компаниями
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Страничка психотерапевта' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Страничка психотерапевта'}">Страничка психотерапевта
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Страничка офтальмолога' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Страничка офтальмолога'}">Страничка офтальмолога
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="dropdown"
                :class="$route.name === 'Программы медицинского обслуживания' || $route.name === 'Стерилизация медицинских изделий' || $route.name === 'Медицинские осмотры по приказу 29н' ? 'active' : ''">
                <a class="dropdown-link" href="#">Партнерам</a>
                <ul class="dropdown-content">
                    <li :class="$route.name === 'Программы медицинского обслуживания' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Программы медицинского обслуживания'}">Программы медицинского
                            обслуживания
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Медицинские осмотры по приказу 29н' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Медицинские осмотры по приказу 29н'}">Медицинские осмотры по
                            приказу 29Н
                        </router-link>
                    </li>
                    <li :class="$route.name === 'Стерилизация медицинских изделий' ? 'active' : ''">
                        <router-link tag="a" :to="{name: 'Стерилизация медицинских изделий'}">Стерилизация медицинских
                            изделий
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="dropdown" :class="$route.name === 'Новости' ? 'active' : ''">
                <router-link tag="a" :to="{name: 'Новости'}" class="dropdown-link">Новости</router-link>
            </li>
            <li class="dropdown" :class="$route.name === 'Контакты' ? 'active' : ''">
                <router-link tag="a" :to="{name: 'Контакты'}" class="dropdown-link">Контакты</router-link>
            </li>
            <li class="dropdown">
                <a class="dropdown-link" href="#">a A</a>
                <ul class="dropdown-content">
                    <li>
                        <a id="specialButton" href="#">Версия для слабовидящих</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown-content .inner-list:hover .dropdown-content-inner {
    display: block;
}

.header_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0;
}

.header-layout {
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;

    &__submenu {

        display: flex;
        justify-content: center;
        margin-bottom: -8px;

        @media screen and (max-width: 960px) {
            flex-wrap: wrap;
            justify-content: flex-start;
        }

        li > ul {
            display: none;
        }

        li:hover > .dropdown-content {
            display: block;
        }

        li a {
            padding: 15px;
            font-family: 'arial', sans-serif;
            color: #888;
            font-size: 13px;
        }

        .dropdown {
            &:hover, &.active {
                &:after {
                    display: none;
                }
            }

            &:after {
                z-index: 1;
                content: '';
                display: block;
                width: 1px;
                position: absolute;
                top: 2px;
                right: 0;
                height: 19px;
                background-color: #bcbcbc;
            }
        }

        li.active .dropdown-link, li:hover .dropdown-link {
            background-color: #00b6cc;
            border-color: #42B3E5;
            color: #FFF;
            margin-left: -1px;
        }


        .dropdown {
            position: relative;
            display: inline-block;
            height: 35px;
            z-index: 9;
        }

        .dropdown-content {
            padding: 12px 15px;
            display: none;
            position: absolute;
            width: 190px;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            z-index: 1;
            left: 0;
            top: 33px;
            background-color: #fff;
        }

        .inner-list {
            position: relative;
        }

        .dropdown-content-inner {
            padding: 0 15px 12px;
            display: none;
            position: absolute;
            right: -190px;
            top: -12px;
            width: 190px;
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
            z-index: 1;
            background-color: #fff;
        }

        .dropdown-content li {
            min-height: 43px;
            width: 160px;
        }

        .dropdown-content a {
            text-align: left;
            padding: 15px 0;
            color: #888;
            font-size: 12px;
            line-height: 1.0;
            text-decoration: none;
            display: block;
            border-bottom: 1px solid #b2b2b2;
        }

        .dropdown-content a:hover, .dropdown-content li.active > a {
            color: black;
            border-bottom: 2px solid #00b6cc;
        }
    }

    &--left {
        img {
            width: 400px;
        }

        @media screen and (max-width: 420px) {
            img {
                width: 90%;
            }
        }
    }

    .right-button a {
        background-color: unset;
        border: 1px solid #006688;
        color: #006688;
        font-size: 15px;
        font-weight: bold;
        padding: 10px 20px;
        float: right;
        text-decoration: none;
    }

    .right-button:hover a {
        background-color: #006688;
        color: #FFF;
    }
}

.border-top-header {
    border-top: 1px solid #E8E8E8;
    padding-top: 10px;

}

.textwidget {
    display: flex;
    justify-content: flex-start;
}

.textwidget a:hover {
    background-color: #00b6cc;

}

.textwidget a {
    color: rgb(255, 255, 255);
    background-color: rgb(160, 32, 96);
    border-color: rgb(160, 32, 96);
    padding: 5px 24px 7px 8px;
    font-size: 12px;
    font-weight: bold;
}

.header_top_sidebar_container {
    background-color: #F7F7F7;
    border-bottom: 1px solid #EDEDED;
}

.header_top_sidebar {
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;
}


@media screen and (max-width: 768px) {
    .header-layout {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 5px;
    }

    .header_top_sidebar {
        width: 100%;
    }

    .textwidget {
        justify-content: center;
    }
}
</style>
